import React from "react";
import translate from 'react-i18next/dist/commonjs/translate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import { Select } from "antd";
import { allocationStatus, allocationStatusT, allocationType, allocationTypeT } from '../../../common/enums';
import DatePicker from 'antd/lib/date-picker';
import InterestFilter from './filters/Interest';
import config from '../../../config';
import { CalculatorSlider } from "../../../common/components";
import { monthsFormatter, percentageFormatter } from "../../../common/utils/helpers";
import Slider from 'antd/lib/slider';
import MediaQuery from 'react-responsive';
import * as moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;



@translate()
export default class AllocationsFilter extends React.Component {


    state = {
        interest: [],
        months: [],
    }

    componentDidMount(){
        const { filter } = this.props
        this.setState({
            interest: filter.interest.length === 0 ? [this.props.interestMin,this.props.interestMax] : filter.interest,
            months: filter.months.length === 0 ? [this.props.minMonths,this.props.maxMonths] : filter.months
        });
    }

    onChangeInterest = value => {
        this.setState({
            ...this.state,
            interest: value
        })
    }

    onAfterInterestChange = (value) => {
        this.props.onChange(value, "interest")
    }

    onChangeMonths = value => {
        this.setState({
            ...this.state,
            months: value
        })
    }

    onAfterMonthsChange = (value) => {
        this.props.onChange(value, "months")
    }


    render() {
        const { t, filter, onChange, minMonths, maxMonths, interestMin, interestMax } = this.props
        const { interest, months } = this.state

        const getInterestSliderMarks = ({ min, max }) => ({
            [min]: <span>{percentageFormatter(min)}</span>,
            [max]: <span>{percentageFormatter(max)}</span>,
        });

        const sliderMonthMarks = {
            [minMonths - 1]: <span>{monthsFormatter(minMonths,true)}</span>,
            [maxMonths + 1]: <span>{monthsFormatter(maxMonths,true)}</span>,
        };

        const interestSliderMarks = getInterestSliderMarks({
            min: interestMin,
            max: interestMax,
        });
        return (
            <div className="panel-wrapper">
                <Row className="filters">
                    <Col xs={12} md={4}>
                        <Select
                            placeholder={t('Typ alokácie')}
                            key="Type"
                            defaultValue={filter.type}
                            onChange={(value) => onChange(value, "type")}
                        >
                            <Option key="" value="">
                                {t('Všetky typy')}
                            </Option>
                            {Object.entries(allocationTypeT).map(([key, value]) => (
                                <Option key={key} value={key}>
                                {value}
                                </Option>
                            ))}

                        </Select>
                    </Col>
                    <Col xs={12} md={4}>
                        <Select
                            placeholder={t('Stav alokácie')}
                            key="Status"
                            defaultValue={filter.status}
                            onChange={(value) => onChange(value, "status")}
                        >
                            <Option value="">
                                {t('Všetky stavy')}
                            </Option>
                            {Object.entries(allocationStatusT).filter(([key, value]) => key !== allocationStatus.PARTIALLY_INVESTED).map(([key, value]) => (
                                <Option key={key} value={key}>
                                {value}
                                </Option>
                            ))}

                        </Select>
                    </Col>
                    <Col xs={12} md={4}>
                        <RangePicker
                            format="DD.MM.YYYY"
                            key="createdAt"
                            value={filter.createdAt}
                            onChange={
                            ([dateFrom, dateTo]) => {
                                onChange([dateFrom, dateTo], "createdAt");
                            }
                            }
                        />
                    </Col>
                </Row>
                <div style={{padding: 10+'px'}}></div>
                <Row className="filters padded ant-form-explain">
                    <Col xs={12} md={5} >
                        
                        <p>{t('Úrok:')} </p>
                        
                        <Slider
                            range={true}
                            min={interestMin}
                            max={interestMax}
                            step={0.001}
                            value={interest}
                            marks={interestSliderMarks}
                            // disabled={!amount}
                            tipFormatter={percentageFormatter}
                            onChange={this.onChangeInterest}
                            onAfterChange={this.onAfterInterestChange}
                        />
                    </Col>  
                    <Col xs={12} mdOffset={2} md={5} className="term-months">     
                       
                        <p>{t('Dĺžka investície:')} </p>
                                     
                        <Slider
                            tipFormatter={val => monthsFormatter(val, true)}
                            onChange={this.onChangeMonths}
                            onAfterChange={this.onAfterMonthsChange}
                            min={minMonths}
                            max={maxMonths}
                            value={months}
                            // defaultValue={this.props.filter.termMonths}
                            step={1}
                            range={true}
                            marks={sliderMonthMarks}
                        /> 
                    </Col>

                </Row>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/features/allocations/components/AllocationsFilter.js